export default {
  name: "dr-card",
  props: {
    name: {
      type: String,
      required: true
    },
    nbDices: {
      type: Number,
      required: true
    },
    timestamp: {
      type: Number,
      required: true
    }
  }
};
